import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // إذا لم يكن المستخدم مسجل الدخول، سيتم توجيهه إلى صفحة تسجيل الدخول
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  
  // إذا كان المستخدم مسجل الدخول، سيتم عرض المحتوى المحمي
  return children;
};

export default ProtectedRoute; 